// Report `moduleId` values may come prefixed as `module::<id>` or `module_group::<id>`,
// while `ReportModuleGroup.id` values are always plain, lower-cased ids.
// Lower-case first so the prefix strip matches regardless of the casing the API returns.
export function normalizeModuleId(moduleId: string): string {
    return moduleId
        .toLocaleLowerCase()
        .replace('module::', '')
        .replace('module_group::', '');
}
